import { signalStore, withState } from "@ngrx/signals";
import { initialProviderServiceState } from "./provider-service.state";
import { withProviderServiceApiMethods } from "./provider-service.methods.api";
import { withProviderServiceStateMethods } from "./provider-service.methods.state";
import { withProviderServiceComputed } from "./provider-service.computed";

export const ProviderServiceStore = signalStore(
    { providedIn: 'root' },
    withState(initialProviderServiceState),
    withProviderServiceApiMethods,
    withProviderServiceStateMethods,
    withProviderServiceComputed
);
